import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
  })
  export class TimelineItemService {

    constructor(
    ) {}


    addCommentToYourMoodAction (timelineItemId: string){
        const selector = '#item-' + timelineItemId + ' .card-add-comment';
        const moodToFill = document.querySelector(selector);
        setTimeout(() => {
            const click = new Event( 'click', { bubbles: true } );
            moodToFill.dispatchEvent( click );
            setTimeout(() => {
                const moodToFillInputSelector = '#item-' + timelineItemId + ' #mood-textarea-to-edit';
                const moodToFillInput: any = document.querySelector(moodToFillInputSelector);
                moodToFillInput.focus();
            }, 400);
        }, 400)
    }

}